export default "__VITE_ASSET__eadd18fc__"